import { useLayoutEffect, useRef, useState } from "react";
import { cn } from "@/utils/css";

const GAP_PX = 8;

// Label anchored above (x, y) inside a chart, clamped to the chart's width. It measures itself
// after render, so at an edge the first frame can be a few px off.
export const ChartHoverTooltip = ({ x, y, containerWidth, className, children }) => {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);

    useLayoutEffect(() => {
        if (ref.current) setWidth(ref.current.offsetWidth);
    });

    const half = width / 2;
    const left = containerWidth > 0 && width > 0 ? Math.min(containerWidth - half, Math.max(half, x)) : x;

    return (
        <div
            ref={ref}
            className={cn(
                "pointer-events-none absolute z-elevated flex -translate-x-1/2 -translate-y-full flex-col items-center whitespace-nowrap rounded-lg bg-cm-p-surface px-2 py-1 backdrop-blur-[2px] drop-shadow-[0px_2px_2.5px_rgba(0,0,0,0.04)]",
                className,
            )}
            style={{ left, top: y - GAP_PX }}
        >
            {children}
        </div>
    );
};
